export const routes = [
  {
    path: "/",
    component: () => import(/* webpackChunkName: "Common" */ "./layouts/front/index.vue"),
    children: [
      // 결제 강제 취소시 화면
      {
        path: "/fail",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/toss/fail.vue"),
      },

      // TESTS
      {
        path: "tests",
        component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
        children: [
          {
            path: "/",
            component: () => import(/* webpackChunkName: "Common" */ "@/tests/index.vue"),
          },

          // 로켓웍스
          {
            path: "rocket-works",
            component: () => import(/* webpackChunkName: "Common" */ "@/tests/rocket-works/api.vue"),
          },
        ],
      },

      // BEST (메인)
      {
        path: "/",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/home.vue"),
      },

      // BEST (메인) (/index.html 대응)
      {
        path: "/index.html",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/home.vue"),
      },

      // 예약하기
      {
        path: "reservation",
        component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
        children: [
          {
            path: "category",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/reservation/category.vue"),
          },
          {
            path: "buy",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/reservation/buy.vue"),
          },
          {
            path: "complete",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/reservation/complete.vue"),
          },
        ],
      },
      {
        // 캐슬 소개
        path: "castle",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/concept/sela_castle_introduce.vue"),
      },
      {
        path: "castle/:conceptId",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/concept/sela_concept_detail.vue"),
      },

      // 촬영컨셉
      {
        path: "concept",
        component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
        children: [
          {
            path: "lafia_castle",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/concept/lafia_castle.vue"),
          },
          {
            path: "solo_premium",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/concept/solo_premium.vue"),
          },
        ],
      },
      // 결제 강제 취소시 화면
      {
        path: "makeup",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/makeup/guide.vue"),
      },

      // 리뷰 (테스트용)
      {
        path: "review",
        component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
        children: [
          {
            path: "concept",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/review/ReviewList.vue"),
          },
        ],
      },

      // 스토어
      {
        path: "/store",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/store.vue"),
      },

      // 쿠폰 사용
      {
        path: "/coupon",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/coupon.vue"),
      },

      // 오시는 길
      {
        path: "/location",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/location.vue"),
      },

      // 후기/팁
      {
        path: "/board",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/board.vue"),
      },

      // 상세페이지
      {
        path: "/detail",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/detail.vue"),
      },

      // 마이페이지
      {
        path: "mypage",
        component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
        children: [
          {
            path: "home",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/mypage/home.vue"),
          },
          {
            path: "select",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/mypage/select.vue"),
          },
        ],
      },

      // Auth
      {
        path: "auth",
        component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
        children: [
          {
            path: "login",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/Login.vue"),
          },
          {
            path: "logout",
            component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/Logout.vue"),
          },
          {
            path: "join",
            component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
            children: [
              {
                path: "agree",
                component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/join/agree.vue"),
              },
              {
                path: "form",
                component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/join/form.vue"),
              },
              {
                path: "snsJoinForm",
                component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/join/snsJoinForm.vue"),
              },
            ],
          },
          {
            path: "find",
            component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
            children: [
              // {
              //   path: "id",
              //   component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/find/id.vue"),
              // },
              {
                path: "password",
                component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/find/password.vue"),
              },
              {
                path: "confirm",
                component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/find/confirmUser.vue"),
              },
              {
                path: "success",
                component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/find/foundedId.vue"),
              },
            ],
          },
          {
            path: "sns",
            component: () => import(/* webpackChunkName: "Common" */ "@/layouts/empty.vue"),
            children: [
              {
                path: "google",
                component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/sns/google.vue"),
              },
              {
                path: "naver",
                component: () => import(/* webpackChunkName: "Common" */ "@/views/auth/sns/naver.vue"),
              },
            ],
          },
        ],
      },
      // Policy
      {
        path: "policy",
        component: () => import(/* webpackChunkName: "Policy" */ "@/layouts/empty.vue"),
        children: [
          {
            path: "rule",
            component: () => import(/* webpackChunkName: "Policy" */ "@/views/policy/Rule.vue"),
          },
          {
            path: "privacy",
            component: () => import(/* webpackChunkName: "Policy" */ "@/views/policy/Privacy.vue"),
          },
        ],
      },

      // kiosk online 결제 연동
      {
        path: "onlinePayConnect",
        component: () => import(/* webpackChunkName: "Policy" */ "@/views/kiosk/payConnect.vue"),
      },
      {
        path: "onlinePaySuccess",
        component: () => import(/* webpackChunkName: "Policy" */ "@/views/kiosk/payComplete.vue"),
      },
      {
        path: "offlinePayReqCompl",
        component: () => import(/* webpackChunkName: "Policy" */ "@/views/kiosk/offlinePayComplete.vue"),
      },

      // 미션
      {
        path: "traveler/missions",
        component: () => import(/* webpackChunkName: "Policy" */ "@/views/missions/travelerMissions.vue"),
      },
      {
        path: "traveler/missions/:missionId",
        component: () => import(/* webpackChunkName: "Policy" */ "@/views/missions/travelerMissionDetail.vue"),
      },
    ],
  },

  // 관리자
  {
    path: "/admin",
    component: () => import(/* webpackChunkName: "Admin" */ "@/layouts/admin/index.vue"),
    children: [
      // Auth
      {
        path: "auth",
        component: () => import(/* webpackChunkName: "Admin" */ "@/layouts/empty.vue"),
        children: [
          {
            path: "login",
            component: () => import(/* webpackChunkName: "Admin" */ "@/views/admin/auth/login.vue"),
          },
          {
            path: "logout",
            component: () => import(/* webpackChunkName: "Admin" */ "@/views/admin/auth/logout.vue"),
          },
        ],
      },

      /* 메이커 */

      // 라피아캐슬 관리
      {
        path: "lafia_castle",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/lafia_castle.vue"),
      },

      {
        path: "castle/onsite",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/castle/onsite-processing.vue"),
      },

      // 솔로프리미엄 관리
      {
        path: "solo_premium",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/solo_premium.vue"),
      },

      // 컨셉 관리
      {
        path: "concept",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/concept.vue"),
      },

      // 컨셉 자동촬영 설정 관리
      {
        path: "concept_auto",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/concept_auto.vue"),
      },

      // 스토어 관리
      {
        path: "store",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/store.vue"),
      },

      // 리뷰 관리
      {
        path: "review",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/review.vue"),
      },

      // 회원 관리
      {
        path: "user",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/user.vue"),
      },
      // 결제내역 관리
      {
        path: "payments",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/payments/search.vue"),
      },

      // 프로모션 관리
      {
        path: "promotion",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/promotion.vue"),
      },

      // 알림 내역
      {
        path: "notifications",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/notifications.vue"),
      },

      /* 관리자 */

      // HOME 관리
      {
        path: "home",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/home.vue"),
      },

      // LOCATION 관리
      {
        path: "location",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/location.vue"),
      },

      // 자주묻는질문 관리
      {
        path: "qna",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/qna.vue"),
      },

      // 이용약관 관리
      {
        path: "rule",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/rule.vue"),
      },

      // 키오스크 이용약관 관리
      {
        path: "kioskRule",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/kioskRule.vue"),
      },

      // 개인정보처리방침 관리
      {
        path: "privacy",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/privacy.vue"),
      },

      // 매출 관리
      {
        path: "sale",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/sale.vue"),
      },
      // 통계 관리
      {
        path: "stats",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/stats/sela.vue"),
      },

      // 메이커 관리
      {
        path: "maker",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/maker.vue"),
      },

      // 직원 관리
      {
        path: "staff",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/staff.vue"),
      },

      // 캐슬 둘러보기 관리
      {
        path: "sela-castle",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/castle/introduce.vue"),
        children: [],
      },
      {
        path: "conceptbooth/setting",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/conceptBooth/setting.vue"),
      },
      {
        path: "travelers/missions",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/missions/travelerMissions.vue"),
      },
      {
        path: "travelers/missions/comments",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/missions/travelerComments.vue"),
      },
      {
        path: "offile-pay",
        component: () => import(/* webpackChunkName: "Common" */ "@/views/admin/offline/pay.vue"),
      },
    ],
  },

  // 토스페이먼츠
  {
    path: "/toss",
    component: () => import(/* webpackChunkName: "policy" */ "@/layouts/toss/index.vue"),
    children: [
      {
        path: "success",
        component: () => import(/* webpackChunkName: "policy" */ "@/views/toss/success.vue"),
      },
    ],
  },
]
